import styled from "styled-components";

export const fontBodega = '"BodegaSansUEFA26", system-ui, sans-serif';

const mainBlue = "#0033cc";
const headerBlue = "#0085ff";
const logosBandBlue = "#156fe8";
const logosBandHeightPx = 130;
const bridgeLiftAboveBandPx = 0;
const decoThingyBottomPx = logosBandHeightPx + bridgeLiftAboveBandPx;

/** Keep body copy inside a band that clears fixed-width side art on narrow screens */
const textColumnSideReservePx = 112;

export const MainContainer = styled.main`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 480px;
  margin: 0 auto;
  min-height: 100vh;
  background-color: ${mainBlue};
  overflow-x: hidden;
`;

export const Navbar = styled.nav`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  gap: 8px;
  padding: 16px 20px;
  background: ${headerBlue};
  flex-shrink: 0;

  img {
    height: 27px;
    width: auto;
  }

  .balance-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 4px;
  }

  && .balance-text {
    color: #fff;
    font-family: ${fontBodega};
    font-size: 17px;
    font-weight: 500;
    line-height: 22px;
    letter-spacing: 0.2px;
    text-transform: uppercase;
  }

  && .balance-value {
    color: #fff;
    font-family: ${fontBodega};
    font-size: 23px;
    font-weight: 500;
    line-height: 26px;
    letter-spacing: 0.2px;
  }

  && .balance-figma {
    color: #fff;
    font-family: ${fontBodega};
    font-size: 22px;
    font-weight: 500;
    line-height: 26px;
    letter-spacing: 0.2px;
    text-align: right;
  }
`;

export const BodySection = styled.section`
  position: relative;
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 520px;
  background: ${mainBlue};
`;

export const BrandingBand = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: ${logosBandHeightPx}px;
  background: ${logosBandBlue};
  z-index: 1;
  pointer-events: none;
`;

export const DecoThingy = styled.img`
  position: absolute;
  left: 50%;
  bottom: ${decoThingyBottomPx}px;
  transform: translateX(-50%);
  width: min(108%, 440px);
  max-width: none;
  height: auto;
  z-index: 2;
  pointer-events: none;
`;

/** Partner logos inside lighter band */
export const LogosBar = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 2;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  padding: 0 20px 8px;
  pointer-events: none;

  img {
    width: 160px;
    height: auto;
    max-width: 100%;
    display: block;
    pointer-events: auto;
  }
`;

export const ArtLayer = styled.div`
  position: absolute;
  inset: 0;
  pointer-events: none;
  z-index: 3;
  overflow: hidden;
`;

export const DecoLeft = styled.img`
  position: absolute;
  left: 0;
  bottom: 0;
  width: clamp(64px, 30vw, 136px);
  height: auto;
`;

export const DecoRight = styled.img`
  position: absolute;
  right: 0;
  bottom: 0;
  width: clamp(72px, 34vw, 171px);
  height: auto;
`;

/** Vector headline asset (Figma export) */
export const WelcomeTitle = styled.img`
  display: block;
  width: 100%;
  max-width: 150px;
  height: auto;
  margin: 0;
`;

export const ContentContainer = styled.div`
  position: relative;
  z-index: 2;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  padding: 24px clamp(18px, 5vw, 28px) 220px;
  width: 100%;
  box-sizing: border-box;

  .text-column {
    max-width: min(236px, calc(100% - ${textColumnSideReservePx}px));
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 14px;
  }

  && p {
    color: #fff;
    text-align: center;
    font-family: ${fontBodega};
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: 0.5px;
    margin: 0;
  }

  && .highlight-text {
    color: #7fbbea;
    font-family: ${fontBodega};
    font-weight: 400;
  }

  && a {
    font-family: ${fontBodega};
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0.5px;
    text-decoration: underline;
    color: #fff;
  }
`;

export const Footer = styled.footer`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 32px 16px;
  gap: 8px;
  flex-shrink: 0;
  background: ${mainBlue};

  img {
    height: 33px;
  }

  && .powered-by {
    color: #fff;
    font-family: ${fontBodega};
    font-size: 19px;
    font-weight: 500;
    line-height: 26px;
    letter-spacing: 0.2px;
  }

  && .links-text {
    color: #fff;
    font-family: ${fontBodega};
    font-size: 15px;
    font-weight: 500;
    line-height: 22px;
    letter-spacing: 0.15px;
  }
`;
